import {
    SENSOR_TYPES_LOAD_BEGIN,
    SENSOR_TYPES_LOAD_END,
    SENSOR_TYPES_LOAD_ERROR,
    FETCH_SENSOR_TYPES
} from '../actions/actionTypes';

const initialState = {
    data:    [],
    error:   null,
    loading: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SENSOR_TYPES:
            return {
                ...state,
                data: action.payload
            };
        case SENSOR_TYPES_LOAD_BEGIN:
            return {
                ...state,
                error:   initialState.error,
                loading: true
            };
        case SENSOR_TYPES_LOAD_END:
            return {
                ...state,
                loading: false
            };
        case SENSOR_TYPES_LOAD_ERROR:
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
};
